<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Override Reporting Hierarchy</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px" [@routeAnimation]="true">
    <!-- <mat-card> -->
    <form [formGroup]="employeeInfo">
        <mat-form-field>
            <input type="text" placeholder="Employee Id" maxlength="15" matInput required formControlName="EmpId">
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="employeeInfo.invalid" (click)="onSubmit()">Add Override</button>
        <!-- <button mat-raised-button color="primary" (click)="onSubmit()">Add Override</button> -->
    </form>
    <!-- </mat-card> -->

    <div fxLayout="column">
        <div fxLayout="column">
            <mat-form-field class="filter">
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>
        </div>

        <div class="override-loading-shade" *ngIf="isLoading">
            <mat-spinner *ngIf="isLoading"></mat-spinner>
        </div>
        <div class="override-loading-shade" *ngIf="isLoadingResults">
            <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
        </div>

        <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="EmpId">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Employee Id </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.EmpId}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FirstName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.FirstName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LastName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.LastName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DepartmentName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Department Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.DepartmentName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Email">
                <mat-header-cell fxFlex="15" *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
                <mat-cell fxFlex="15" *matCellDef="let row"> {{row.Email}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Title">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Job Title </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.Title}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="managerCC">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Manager CC </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.managerCC}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="managerCA">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Manager CA </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.managerCA}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="director">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Director </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.director}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="VP_CR_CA">
                <mat-header-cell *matHeaderCellDef mat-sort-header> VP-CR&CA </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.VP_CR_CA}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LOB_VP1">
                <mat-header-cell *matHeaderCellDef mat-sort-header> LOB-VP1 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.LOB_VP1}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LOB_VP2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> LOB-VP2 </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.LOB_VP2}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CP_CEO">
                <mat-header-cell *matHeaderCellDef mat-sort-header> CP-CEO </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.CP_CEO}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"> </mat-row>
        </mat-table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>